import React from 'react';
import { DropTarget } from 'react-dnd';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';
import parse from 'date-fns/parse';
import compareAsc from 'date-fns/compare_asc';
import startOfDay from 'date-fns/start_of_day';
import config from '../../config';

import Employees from './Employees';
import getEmployeeById from '../../utils/getEmployeeById';

const spec = {
  /**
   * Handle drop events on the class
   * @param {object} props
   * @param {object} monitor
   * @param component
   * @return {void}
   */
  drop(props, monitor, component) {
    const { id } = monitor.getItem();
    component.addEmployee(id);
  },
};

/**
 * Collect props for the class from React DnD
 * @param {object} connect
 * @param {object} monitor
 * @returns {{connectDropTarget: ConnectDropTarget, isOver: boolean}}
 */
function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    // isOverCurrent: monitor.isOver({ shallow: true }),
    // canDrop: monitor.canDrop(),
    // itemType: monitor.getItemType()
  };
}

class Shift extends React.Component {
  /**
   * Construct.
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
    this.selectShiftId = this.selectShiftId.bind(this);
    this.addEmployee = this.addEmployee.bind(this);
  }

  /**
   * Retrieve the class name that should be applied to the shift
   * @returns {string}
   */
  getClassNames() {
    const { selectedShiftId, shift, isOver } = this.props;

    let selectedClass = '';

    if (selectedShiftId !== null) {
      selectedClass = selectedShiftId === shift.projectIdentifier ? 'is-selected' : 'is-not-selected';
    }

    const overClass = isOver ? 'is-hovered' : '';

    return `${selectedClass} ${overClass}`;
  }

  /**
   * Handles the selection of a project ID, this will highlight them in the overview
   * @return {void}
   */
  selectShiftId() {
    this.props.selectShiftId(this.props.shift.projectIdentifier);
  }

  addEmployee(id) {
    this.props.addEmployee(id);
  }

  /**
   * Render component.
   * @returns {React.Component}
   */
  render() {
    const { shift, color, openShift, connectDropTarget, currentDate } = this.props;

    const classNames = this.getClassNames();

    let employees = uniq(shift.employees).map((employeeId) => {
      const employee = getEmployeeById(employeeId);

      return {
        id: employeeId,
        name: typeof employee.name !== 'undefined' ? employee.name : employee,
        color: typeof employee.color !== 'undefined' ? employee.color : '#eee',
        number: typeof employee.number !== 'undefined' ? employee.number : 9999,
      };
    });

    const currentColumnDate = startOfDay(parse(currentDate));
    const shiftDate = parse(shift.startDate);

    const hasStartedPreviousDay = compareAsc(shiftDate, currentColumnDate) === -1;

    let time = `${shift.startDateTime} - ${shift.endDateTime}`;

    if (hasStartedPreviousDay) {
      time = `-> ${shift.endDateTime}`
    } else if (shift.startDate !== shift.endDate) {
      time = `${shift.startDateTime} ->`;
    }

    employees = sortBy(employees, ['number']);

    const shiftElement = (
      <div className={`daylist__groups-group ${classNames}`} style={{ borderLeftColor: color }}>
        <div className="daylist__groups-time">
          {time} <span className="daylist__groups-shiftname">{shift.shiftName}</span>
          <span className="daylist__groups-projectname" onClick={() => { openShift(shift.id)} }>
            {(shift.projectIdentifier) ? `#${shift.projectIdentifier} - ` : ''} {shift.projectName ? shift.projectName : shift.shiftName}
          </span>

          <button
            className={`daylist__groups-select ${classNames}`}
            type="button"
            onClick={this.selectShiftId}
          >
          </button>
        </div>

        <div className="daylist__groups-employees">
          <Employees
            uniqueKey={shift.id}
            contractor={shift.contractor}
            employees={employees}
          />
          {(shift.requiredUsers > 0) ? (<small className="u-color-mute daylist__groups-count">{employees.length} / {shift.requiredUsers}</small>) : null}
        </div>
      </div>
    );

    return config.writeAccess ? connectDropTarget(shiftElement) : shiftElement;
  }
}

export default DropTarget('group', spec, collect)(Shift);



// WEBPACK FOOTER //
// ./src/components/Grid/Shift.js